import React from 'react'

const InjectablesLightbox = () => {
  return (
    <div className='lightbox__paragraph'>
    <h1>Neuromodulators (Botox®, Nuceiva®)</h1>
    <br />
    <ul>
        <li>• Fine Lines and Wrinkles</li>
        <li>• Bruxism &#40;Teeth Clenching/Grinding&#41;</li>
        <li>• Hyperhidrosis &#40;Excessive Sweating&#41;</li>
    </ul>
    <br />
    <h1>Dermal Fillers</h1>
    <br />
    <ul>
        <li>• Wrinkles</li>
        <li>• Volume Loss</li>
        <li>• Lip Augmentation</li>
        <li>• Facial Contouring &#40;Temples, Cheeks, Jawline&#41;</li>
    </ul>
    <br />
    <p>
        Botox® and Nuceiva® are neuromodulators that target "dynamic" facial wrinkles caused by squinting, frowning, laughing, and other facial expressions. Dermal fillers address fine lines and wrinkles that form due to natural loss of collagen and elastin as we age, starting in the late 20's, as well as loss caused by sun damage. In addition, dermal fillers restore facial contours that change as a result of volume loss related to aging - loss of fat which provides youthful contours, and bone which provides structural support.
        <br />
        <br />
        Our selection of injectables is curated to allow full face rejuvenation, smoothing fine lines and wrinkles, and restoring volume and contours, leaving you looking refreshed and feeling confident.
    </p>
    </div>
  )
}

export default InjectablesLightbox
